/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Polyfill
import 'core-js/stable'
import 'regenerator-runtime/runtime'

require('@rails/ujs').start()
require('@rails/activestorage').start()
require('channels')

const axios = require('axios')

axios.get(`${window.POKER_NOW_PUBLIC_URL}/current-player-infos`, { withCredentials: true })
  .then(function (response) {
    if (response.data.isPremium) {
      const logo = document.querySelector('.main-logo-container > a')

      if (logo) {
        logo.classList.add('with-diamond')
      }
    }

    const nowCoinsBalanceEl = document.getElementById('now-coins-balance')

    if (!nowCoinsBalanceEl) { return }

    const nowCoinsLink = nowCoinsBalanceEl.querySelector('a')

    if (!nowCoinsLink) { return }

    if (response.data.nowCoins !== null) {
      nowCoinsBalanceEl.style.display = 'block'
      nowCoinsLink.textContent = response.data.nowCoins
    }
  })
